export const simulationPartMaximum = 10;